import { render, staticRenderFns } from "./GroupedViewTable.vue?vue&type=template&id=067737e2&"
import script from "./GroupedViewTable.vue?vue&type=script&lang=js&"
export * from "./GroupedViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports